import { defineRecipe } from '@plurall/elo-v3';

export const rootRecipe = defineRecipe({
  className: 'error-boundary',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 'space.24',
    backgroundColor: 'background.primary',

    '@media (max-width: 768px)': {
      padding: 'space.16',
    },
  },
});

export const containerRecipe = defineRecipe({
  className: 'error-boundary-container',
  base: {
    maxWidth: '600px',
    width: '100%',
    textAlign: 'center',
    padding: 'space.32',
    backgroundColor: 'background.primary',
    borderRadius: 'shape.8',
    boxShadow: 'var(--shadow-md)',

    '@media (max-width: 768px)': {
      padding: 'space.24',
    },
  },
});

export const titleRecipe = defineRecipe({
  className: 'error-boundary-title',
  base: {
    fontSize: 'font-size-2xlarge',
    fontWeight: 'font-weight-bold',
    color: 'text.primary',
    marginBottom: 'space.16',

    '@media (max-width: 768px)': {
      fontSize: 'font-size-xlarge',
    },
  },
});

export const messageRecipe = defineRecipe({
  className: 'error-boundary-message',
  base: {
    color: 'text.secondary',
    marginBottom: 'space.24',
  },
});

export const detailsRecipe = defineRecipe({
  className: 'error-boundary-details',
  base: {
    margin: 'space.24 0',
    textAlign: 'left',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.secondary',
    borderRadius: 'shape.4',
    backgroundColor: 'background.secondary',
    overflow: 'hidden',
  },
});

export const summaryRecipe = defineRecipe({
  className: 'error-boundary-summary',
  base: {
    padding: 'space.16',
    cursor: 'pointer',
    fontWeight: 'font-weight-semi-bold',
    color: 'text.primary',
    backgroundColor: 'background.primary',
    userSelect: 'none',

    _hover: { backgroundColor: 'action.hover.brand' },
  },
});

export const errorContentRecipe = defineRecipe({
  className: 'error-boundary-error-content',
  base: {
    fontSize: 'font-size-small',
    padding: 'space.16',
  },
});

export const errorBlockRecipe = defineRecipe({
  className: 'error-boundary-error-block',
  base: {
    marginBottom: 'space.16',

    '&:last-child': { marginBottom: 0 },

    '& strong': {
      display: 'block',
      marginBottom: 'space.4',
      color: 'text.primary',
      fontWeight: 'font-weight-semi-bold',
    },

    '& pre': {
      fontSize: 'font-size-xsmall',
      margin: 0,
      padding: 'space.8',
      backgroundColor: 'background.primary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'border.secondary',
      borderRadius: 'shape.4',
      color: 'foreground.feedback.error.primary',
      overflowX: 'auto',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
  },
});

export const actionsRecipe = defineRecipe({
  className: 'error-boundary-actions',
  base: {
    display: 'flex',
    gap: 'space.16',
    justifyContent: 'center',
    marginTop: 'space.32',
    flexWrap: 'wrap',

    '@media (max-width: 768px)': {
      flexDirection: 'column',
      '& button': { width: '100%' },
    },
  },
});
